import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import isAbsoluteUrl from 'is-absolute-url';

import { useTheme } from '@emotion/react';

const prefixIfNeeded = (href, isViewer) => {
  if (!href) return href;
  // already prefixed
  if (href.startsWith('/NBH')) return href;

  // only adjust 2005 internal links
  if (href.startsWith('/2005')) {
    return isViewer ? `/NBH${href}` : href;
  }

  return href;
};

const Link = ({ to, ...props }) => {
  const theme = useTheme();
  const isViewer = theme.isViewer;

  if (isAbsoluteUrl(to)) {
    return (
      <a href={to} {...props}>
        {props.children}
      </a>
    );
  }

  const adjustedTo = prefixIfNeeded(to, isViewer);

  return <GatsbyLink to={adjustedTo} {...props} />;
};

export default Link;
